import {
    getData,
} from './Services'

import { getOrderCacheDetailPanel } from './OrderCacheDetailServices'
export const getOrderCacheLista = async () => {
  const res = await getData('/ordercache');
  return res
}


export const getOrderCacheById = async (id) => {
  const res = await getData(`/ordercache/${id}`)
  return res
}

export const getOrderCachePanel = async (searchCli, searchSel, dateFrom, dateUntil, page, perPage) => {
  let queryParams = [];

  if (searchCli) queryParams.push(`cli_id=${encodeURIComponent(searchCli)}`);
  if (searchSel) queryParams.push(`sel_id=${encodeURIComponent(searchSel)}`);
  if (dateFrom) queryParams.push(`fechaDesde=${encodeURIComponent(dateFrom)}`);
  if (dateUntil) queryParams.push(`fechaHasta=${encodeURIComponent(dateUntil)}`);
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (perPage) queryParams.push(`perPage=${encodeURIComponent(perPage)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  try {
    const res = await getData("/ordercache/busquedaOrderCache_filtros", queryString);
    return res;
  } catch (err) {
    console.error("Error al obtener historial de pedidos con filtros", err);
    return { pedidos: [], pagination: { totalItems: 0 } };
  }
};

 